import { render, staticRenderFns } from "./UnauthorizedPage.vue?vue&type=template&id=45a86409&scoped=true"
import script from "./UnauthorizedPage.vue?vue&type=script&lang=js"
export * from "./UnauthorizedPage.vue?vue&type=script&lang=js"
import style0 from "./UnauthorizedPage.vue?vue&type=style&index=0&id=45a86409&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a86409",
  null
  
)

export default component.exports